import { TranslationStrings } from '@/reducers/releaseStep';
import { RecursiveStringifyEnums } from '@/testData/buildDistro';

export const generateTranslationsDemoData = (): TranslationStrings => {
    const rawObject: RecursiveStringifyEnums<TranslationStrings> = {
        byKey: {
            login: {
                key: 'login',
                isNew: false,
                fileName: 'Localizable.strings',
                status: 'openPR',
                values: [
                    {
                        locale: 'en-US',
                        value: 'Log in',
                        status: 'openPR',
                    },
                    {
                        locale: 'es-ES',
                        value: 'Iniciar sesión',
                        status: 'synced',
                    },
                ],
                openPRNumber: '123',
                exportPRNumber: null,
            },
            subscribe: {
                key: 'subscribe',
                isNew: true,
                fileName: 'Localizable.strings',
                status: 'translationsPending',
                values: [
                    {
                        locale: 'en-US',
                        value: 'Subscribe',
                        status: 'translationsPending',
                    },
                    {
                        locale: 'es-ES',
                        value: 'Suscribirse',
                        status: 'translationsPending',
                    },
                ],
                openPRNumber: null,
                exportPRNumber: null,
            },
            refresh: {
                key: 'refresh',
                isNew: false,
                fileName: 'Localizable.strings',
                status: 'branchUpdatePROpen',
                values: [
                    {
                        locale: 'en-US',
                        value: 'Refresh',
                        status: 'translationsPending',
                    },
                    {
                        locale: 'es-ES',
                        value: 'Actualizar',
                        status: 'branchUpdatePROpen',
                    },
                ],
                openPRNumber: '456',
                exportPRNumber: null,
            },
            error: {
                key: 'error',
                isNew: true,
                fileName: 'Localizable.strings',
                status: 'branchUpdateNeeded',
                values: [
                    {
                        locale: 'en-US',
                        value: 'Something went wrong',
                        status: 'translationsPending',
                    },
                    {
                        locale: 'es-ES',
                        value: 'Algo salió mal',
                        status: 'branchUpdateNeeded',
                    },
                ],
                openPRNumber: null,
                exportPRNumber: null,
            },
            logout: {
                key: 'logout',
                isNew: true,
                fileName: 'Localizable.strings',
                status: 'synced',
                values: [
                    {
                        locale: 'en-US',
                        value: 'Log out',
                        status: 'synced',
                    },
                    {
                        locale: 'es-ES',
                        value: 'Cerrar sesión',
                        status: 'synced',
                    },
                ],
                openPRNumber: null,
                exportPRNumber: null,
            },
            settings: {
                key: 'settings',
                isNew: false,
                fileName: 'Localizable.strings',
                status: 'synced',
                values: [
                    {
                        locale: 'en-US',
                        value: 'Settings',
                        status: 'synced',
                    },
                    {
                        locale: 'es-ES',
                        value: 'Configuración',
                        status: 'synced',
                    },
                ],
                openPRNumber: null,
                exportPRNumber: null,
            },
            profile: {
                key: 'profile',
                isNew: false,
                fileName: 'Localizable.strings',
                status: 'exportNeeded',
                values: [
                    {
                        locale: 'en',
                        value: 'Profile',
                        status: 'translationsPending',
                    },
                    {
                        locale: 'es',
                        value: 'Perfil',
                        status: 'exportNeeded',
                    },
                ],
                openPRNumber: '321',
                exportPRNumber: null,
            },
            loading: {
                key: 'loading',
                isNew: false,
                fileName: 'Localizable.strings',
                status: 'synced',
                values: [
                    {
                        locale: 'en',
                        value: 'Loading...',
                        status: 'synced',
                    },
                    {
                        locale: 'es',
                        value: 'Cargando...',
                        status: 'synced',
                    },
                ],
                openPRNumber: null,
                exportPRNumber: null,
            },
        },
        workingBranchStrings: {},
        sourceLocale: 'en-US',
        providerState: {
            branchId: null,
            branchName: null,
            translatedKeyCount: {
                'en-US': 8,
                'es-ES': 8,
            },
            keyCount: {
                'en-US': 16,
                'es-ES': 16,
            },
        },
    };

    rawObject.workingBranchStrings = rawObject.byKey;
    return rawObject as TranslationStrings;
};
